import type { Address } from '@einwert/valuation-api-client'
import { joinDefinedStrings, Map, Marker, tokens } from 'ComponentLibrary'
import { getMapsApiKey } from 'ComponentLibrary/src/common/environment'
import { Box, Stack } from '@mui/material'
import { Headline } from 'ComponentLibrary/src/piazza/text/Headline/Headline'
import { MapPinIcon } from '@phosphor-icons/react'
import { Typography } from 'ComponentLibrary/src/piazza'

import { useTranslation } from 'react-i18next'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'

export const AssetLocation = ({ address }: { address: Address }) => {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })
    const locale = useCurrentResolvedLocale()
    const { coordinates, street, zip, city, country, state, house_number } = address
    const streetAndHouseNumber = joinDefinedStrings([street, house_number], ' ')
    const zipAndCity = joinDefinedStrings([zip, city], ' ')
    const stateAndCountry = joinDefinedStrings([state, country], ', ')

    return (
        <Stack direction="row" gap={tokens.SizingSpacing300} justifyContent="space-between" height="100%">
            <Stack direction="column" gap={tokens.SizingSpacing150} width="100%">
                <Headline title={tCommon('location')} variant="headline3" />
                <Stack direction="row" gap={tokens.SizingSpacing100}>
                    <MapPinIcon size={tokens.SizingIconM} color={tokens.ColorIconBoldest} />
                    <Stack direction="column" gap={tokens.SizingSpacing025}>
                        <Typography variant="textS" color={tokens.ColorTextDefault}>
                            {streetAndHouseNumber}
                        </Typography>
                        <Typography variant="textS" color={tokens.ColorTextDefault}>
                            {zipAndCity}
                        </Typography>
                        <Typography variant="textS" color={tokens.ColorTextDefault}>
                            {stateAndCountry}
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>
            {coordinates && (
                <Box height="100%" width="100%" borderRadius={tokens.SizingCornerM} overflow="hidden">
                    <Map
                        center={{ lat: coordinates.latitude, lng: coordinates.longitude }}
                        apiKey={getMapsApiKey()}
                        language={locale}
                        defaultZoom={9.4}
                        hasControl={false}
                        options={{ zoomControl: false, scrollwheel: false, fullscreenControl: false }}
                    >
                        <Marker lat={coordinates?.latitude} lng={coordinates?.longitude} />
                    </Map>
                </Box>
            )}
        </Stack>
    )
}
